import React, { useEffect } from "react";
import iconImg from "./iconImg.png";
import SiteDetails from "./SiteDetails";
import "./Sites.css";
import Footer from "./Footer";

function Sites() {
  return (
    <div>
      <div className="sites">
        <div className="sites__left">
          <h3>Categories</h3>
          <ul>
            <a href="#trending">
              <li>Trending</li>
            </a>
            <a href="#ai">
              <li>Artificial Intelligence</li>
            </a>

            <a href="#learn">
              <li>Learning Platforms</li>
            </a>
            <a href="#e-commerce">
              <li>E-commerce</li>
            </a>
            <a href="">
              <li>Remote Work</li>
            </a>
            <a href="">
              <li>Travel</li>
            </a>
            <a href="">
              <li>Art & Design</li>
            </a>
            <a href="">
              <li>Productivity</li>
            </a>
            <a href="">
              <li>Fashion</li>
            </a>
          </ul>
        </div>

        <div className="sites__center">
          <h3 className="sectionName" id="trending">
            # Trending 🐱‍🏍🐱‍🏍
          </h3>
          <SiteDetails
            link="https://towardsdatascience.com"
            image="https://cdn-images-1.medium.com/v2/resize:fill:128:128/1*VzTUkfeGymHP4Bvav-T-lA.png"
            siteName="Towards Data Science"
            description="This platform offers articles and tutorials on various AI and machine learning topics."
          />
          <SiteDetails
            link="https://www.marketingprofs.com/"
            image="https://www.marketingprofs.com/favicon.ico"
            siteName="MarketingProfs"
            description="Focuses on practical marketing tips, strategies, and best practices."
          />
          <SiteDetails
            link="https://stackoverflow.com/"
            image="https://stackoverflow.com/favicon.ico"
            siteName="Stack Overflow"
            description="Stack Overflow is an invaluable platform where developers seek solutions and share knowledge to overcome coding challenges."
          />
          <SiteDetails
            link="https://voice.ai"
            image="https://voice.ai/favicon.ico"
            siteName="Voice AI"
            description="Free Real Time Voice Changer And the largest ecosystem of Free AI Voice tools"
          />
          <SiteDetails
            link="https://rytr.me/"
            image="https://storage.googleapis.com/rytr-me/public/favicon/favicon-32x32.png"
            siteName="Rytr"
            description="An AI writing assistant that allows you to create content tailored to your needs in over 30 languages and 20 tones, providing 40+ use cases and templates for different content types."
          />
          <SiteDetails
            link="https://www.beautiful.ai/"
            image="https://www.beautiful.ai/favicon.ico"
            siteName="beautiful.ai"
            description="An AI-powered solution for creating awesome presentations in a short amount of time. It uses artificial intelligence to suggest design ideas and layouts based on your content."
          />
          <h3 className="sectionName" id="ai">
            # Artificial Intelligence
          </h3>
          <SiteDetails
            link="https://www.framer.com/"
            image="https://framerusercontent.com/images/3ydDYhTbVKKzF5xDzZpZKoMmc.png"
            siteName="framer"
            description="AI website builder for businesses."
          />
          <SiteDetails
            link="https://www.adobe.com/products/firefly.html"
            image="https://www.adobe.com/content/dam/cc/Adobe_favicon.ico"
            siteName="Adobe Firefly"
            description=" AI-powered design tool for creatives."
          />
          <SiteDetails
            link="https://www.voicify.ai/"
            image="https://www.voicify.ai/favicon.ico"
            siteName="voicify.ai"
            description="AI-powered voice assistant for businesses."
          />
          <SiteDetails
            link="https://www.leiapix.com/"
            image="https://assets-global.website-files.com/65326edc4027c70cb821c33a/655bb16afb8dbc8b50da73c0_favicon.png"
            siteName="LeiaPix"
            description="Bring Your Images to Life Turn 2D images into captivating 3D animations using LeiaPix AI."
          />
          <SiteDetails
            link="https://leonardo.ai/"
            image="https://leonardo.ai/wp-content/uploads/2022/12/cropped-fav-leonardo-logo-32x32.png"
            siteName="leonardo.ai"
            description="Unleash your Creativity with the power of Leonardo Ai."
          />
          <SiteDetails
            link="https://krisp.ai"
            image="https://krisp.ai/wp-content/uploads/2023/12/cropped-favicon-1-192x192.png"
            siteName="krisp.ai"
            description=" An AI-powered noise-cancelling tool that can remove background noise from audio in real time, improving the quality of voice and video calls."
          />
          <SiteDetails
            link="https://10web.io"
            image="https://10web.io/wp-content/themes/10web-theme/images/favicon.png"
            siteName="10web.io"
            description="A platform that uses AI to assist in website development, including features for design, hosting, and maintenance."
          />
          <SiteDetails
            link="https://brandmark.io"
            image="https://brandmark.io/favicons/project/favicon-32x32.png"
            siteName="Brandmark"
            description="An AI-powered logo maker that uses machine learning to generate unique and professional logos for businesses and brands."
          />
          <SiteDetails
            link="https://www.craiyon.com/"
            image="https://www.craiyon.com/favicon.ico"
            siteName="Craiyon"
            description="A website that lets you draw and create images with artificial intelligence."
          />
          <SiteDetails
            link="https://huggingface.co/"
            image="https://huggingface.co/favicon.ico"
            siteName="Hugging face"
            description="The platform where the machine learning community collaborates on models, datasets, and applications."
          />
          <SiteDetails
            link="https://www.dhiwise.com/"
            image="https://www.dhiwise.com/favicon.ico"
            siteName="DhiWise"
            description="DhiWise is a programming platform that converts designs into developer-friendly code and offers a Smart Editor for customizing UI with real-time design rendering."
          />

          <h3 className="sectionName" id="learn">
            # Learning Platforms
          </h3>
          <SiteDetails
            link="https://www.powerschool.com/"
            image="https://www.powerschool.com/favicon.ico"
            siteName="PowerSchool"
            description=" a learning management system that connects people with the resources and tools they need to personalize learning and improve student outcomes."
          />
          <SiteDetails
            link="https://www.instructure.com"
            image="https://www.instructure.com/themes/custom/themekit/favicon.ico"
            siteName="Instructure"
            description="a cloud-based learning management system that makes teaching and learning easier"
          />
          <SiteDetails
            link="https://www.coursera.org/"
            image="https://www.coursera.org/favicon.ico"
            siteName="coursera"
            description="an online learning platform that offers courses, specializations, and degrees from top universities and companies"
          />
          <SiteDetails
            link="https://www.edx.org/"
            image="https://www.edx.org/favicon.ico"
            siteName="edx"
            description="a massive open online course provider created by Harvard and MIT."
          />
          <SiteDetails
            link="https://www.skillshare.com/"
            image="https://www.skillshare.com/favicon.ico"
            siteName="Skillshare"
            description="an online learning community with thousands of classes in design, business, technology, and more."
          />
          <SiteDetails
            link="https://www.codecademy.com/"
            image="https://www.codecademy.com/favicon.ico"
            siteName="Codecademy"
            description=" an online interactive platform that offers free coding classes in 12 different programming languages."
          />
          <SiteDetails
            link="https://www.pluralsight.com/"
            image="https://www.pluralsight.com/favicon.ico"
            siteName="pluralsight"
            description="an online learning platform that offers courses in software development, IT, data, security, and more."
          />
          <SiteDetails
            link="https://www.rosettastone.com/"
            image="https://www.rosettastone.com/favicon.ico"
            siteName="Rosetta Stone"
            description="a language learning software that uses interactive technology to help people learn new languages."
          />
          <SiteDetails
            link="https://www.duolingo.com/"
            image="https://d35aaqx5ub95lt.cloudfront.net/favicon.ico"
            siteName="Duolingo"
            description="a free language-learning platform that includes a language-learning website and app, as well as a digital language proficiency assessment exam."
          />
          <SiteDetails
            link="https://www.activelylearn.com/"
            image="https://assets-global.website-files.com/59407b2361ef303725423a3f/5f1611a2e86c406cbac8e635_Favicon%2032x32.png"
            siteName="Actively Learn"
            description="an award-winning ELA, science, and social studies curriculum platform designed to engage every student in every lesson."
          />
          <SiteDetails
            link="https://learning.google/"
            image="https://learning.google/static/img/favicon/android-chrome-512x512.png?cache=c56c443"
            siteName="Google Learning"
            description=" a collection of digital learning tools and solutions from Google designed to help everyone in the world learn anything in the world."
          />

          <h3 className="sectionName" id="e-commerce">
            # E-commerce
          </h3>
          <SiteDetails
            link="https://www.amazon.com/"
            image="https://www.amazon.com/favicon.ico"
            siteName="Amazon"
            description="An online marketplace that hosts a wide range of products and services."
          />
          <SiteDetails
            link="https://www.etsy.com/"
            image="https://www.etsy.com/favicon.ico"
            siteName="Etsy"
            description=" An e-commerce platform focused on handmade or vintage items and craft supplies."
          />
          <SiteDetails
            link="https://www.newegg.com/"
            image="https://www.newegg.com/favicon.ico"
            siteName="Newegg"
            description="An online retailer offering computer hardware and consumer electronics."
          />
          <SiteDetails
            link="https://www.rakuten.com/"
            image="https://www.rakuten.com/favicon.ico"
            siteName="Rakuten"
            description="A global e-commerce platform that connects buyers and sellers."
          />
          <SiteDetails
            link="https://www.wayfair.com/"
            image="https://www.wayfair.com/favicon.ico"
            siteName="Wayfair"
            description="An e-commerce company that sells furniture and home-goods."
          />
          <SiteDetails
            link="https://www.bigcommerce.com/"
            image="https://www.bigcommerce.com/favicon.ico"
            siteName="Big Commerce"
            description="A SaaS e-commerce platform that provides a wide range of e-commerce solutions."
          />
          <SiteDetails
            link="https://www.ecwid.com/"
            image="https://www.ecwid.com/favicon.ico"
            siteName="Ecwid"
            description="An e-commerce platform that enables individuals to create their online store."
          />
          <SiteDetails
            link="https://woo.com/"
            image="https://woo.com/wp-content/uploads/2023/08/cropped-Woo_Favicon.png?w=32"
            siteName="WooCommerce"
            description="An open-source e-commerce plugin for WordPress."
          />
          <SiteDetails
            link="https://www.salesforceben.com"
            image="https://www.salesforceben.com/wp-content/uploads/2023/10/cropped-new-favicon-32x32.png"
            siteName="Salesforce Commerce Cloud"
            description="A platform that provides a smart related product recommendation feature to increase sales."
          />
          <SiteDetails
            link="https://www.squarespace.com/"
            image="https://www.squarespace.com/favicon.ico"
            siteName="Squarespace"
            description="A website builder with e-commerce capabilities, offering customizable templates and a user-friendly interface."
          />
          <SiteDetails
            link="https://www.wix.com/"
            image="https://www.wix.com/favicon.ico"
            siteName="Wix"
            description="A website builder that also provides e-commerce functionality with customizable templates and a drag-and-drop editor."
          />
        </div>

        <div className="sites__right">
          <h3>How it works? 👇👇👇</h3>
          <p>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit.
            Voluptatibus optio veritatis officiis possimus id illo officia
            molestiae? Harum amet voluptatum accusantium dolore mollitia.
          </p>
          <a
            style={{ color: "blue", cursor: "pointer" }}
            href=""
            target="_blank"
          >
            Send a message
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Sites;
